import classNames from 'classnames';
import styles from './FJBlankInVideoPanel.module.less';
import PropTypes from 'prop-types';
import FJConfig from '../../../config/FJConfig';
import FJLocalStore from '../../../store/FJLocalStore';
import useLocalStore from '../../../hooks/useLocalStore.js';

const FJBlankInVideoPanel = ({
    active,
    boxDesc = FJConfig.notImageBoxDesc,
    boxTitle = FJConfig.notImageBoxTitle,
    bgUrl = FJConfig.notImageBoxBgUrl,
    videoUrl = FJConfig.notImageBoxVideoUrl,
    bkColor = '#ffffff',
}) => {
    useLocalStore();

    return (
        <div className={classNames(styles.not_image_box, { [styles.active]: active })} style={{ background: bkColor }}>
            <div className={styles.not_image_box_content}>
                <div className={styles.not_image_box_content_title}>
                    <span>{FJLocalStore._(boxTitle)}</span>
                </div>

                <div className={styles.not_image_box_content_desc}>{FJLocalStore._(boxDesc)}</div>

                <div className={styles.video_box}>
                    <video src={videoUrl} autoPlay muted loop />
                </div>
            </div>
            {bgUrl && <img className={styles.not_image_box_bg} src={bgUrl} />}
        </div>
    );
};

FJBlankInVideoPanel.propTypes = {
    active: PropTypes.bool,
    boxDesc: PropTypes.string,
    boxTitle: PropTypes.string,
    bgUrl: PropTypes.string,
    videoUrl: PropTypes.string,
    bkColor: PropTypes.string,
};

export default FJBlankInVideoPanel;
